import { render, staticRenderFns } from "./Caption.vue?vue&type=template&id=735d98bc&scoped=true"
import script from "./Caption.vue?vue&type=script&lang=js"
export * from "./Caption.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Caption.vue?vue&type=style&index=0&id=735d98bc&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "735d98bc",
  null
  ,true
)

export default component.exports